import React, { useEffect, useState } from "react";
import { authFetch, authFetchForm } from "../../api";

const inputClass = "w-full px-4 py-2 rounded-lg bg-white/5 border border-navy-border text-white focus:outline-none focus:border-accent-light";

export default function SiteIdentitySettings() {
  const [data, setData] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [faviconFile, setFaviconFile] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    authFetch("/core/site-identity/")
      .then((res) => res.json())
      .then(setData)
      .catch(() => setError("Failed to load site identity."));
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    try {
      const formData = new FormData();
      formData.append("site_title", data.site_title);
      formData.append("site_tagline", data.site_tagline);
      if (logoFile) formData.append("logo", logoFile);
      if (faviconFile) formData.append("favicon", faviconFile);

      const res = await authFetchForm("/core/site-identity/", formData);
      if (!res.ok) throw new Error();
      const updated = await res.json();
      setData(updated);
      setLogoFile(null);
      setFaviconFile(null);
      setMessage("Site identity updated.");
    } catch {
      setError("Failed to save.");
    }
  };

  if (!data) return <p className="text-gray-400">Loading...</p>;

  return (
    <div className="max-w-2xl">
      <h1 className="text-2xl font-bold mb-2">Site Identity</h1>
      <p className="text-sm text-gray-400 mb-6">
        Logo and favicon are used across the public website and this admin panel.
      </p>

      <form onSubmit={handleSave} className="space-y-6">
        <div className="flex items-center gap-6">
          <div>
            <p className="text-sm text-gray-300 mb-2">Logo</p>
            <img
              src={logoFile ? URL.createObjectURL(logoFile) : data.logo || ""}
              alt="Logo preview"
              className="h-14 bg-white/5 rounded-lg px-3 py-2 object-contain"
              style={{ display: data.logo || logoFile ? "block" : "none" }}
            />
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setLogoFile(e.target.files[0])}
              className="mt-2 text-sm text-gray-300"
            />
          </div>
          <div>
            <p className="text-sm text-gray-300 mb-2">Favicon</p>
            <img
              src={faviconFile ? URL.createObjectURL(faviconFile) : data.favicon || ""}
              alt="Favicon preview"
              className="h-10 w-10 bg-white/5 rounded-lg object-contain"
              style={{ display: data.favicon || faviconFile ? "block" : "none" }}
            />
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setFaviconFile(e.target.files[0])}
              className="mt-2 text-sm text-gray-300"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm text-gray-300 mb-1">Site Title</label>
          <input
            className={inputClass}
            value={data.site_title}
            onChange={(e) => setData({ ...data, site_title: e.target.value })}
          />
        </div>
        <div>
          <label className="block text-sm text-gray-300 mb-1">Site Tagline</label>
          <input
            className={inputClass}
            value={data.site_tagline}
            onChange={(e) => setData({ ...data, site_tagline: e.target.value })}
          />
        </div>

        {message && <p className="text-sm text-green-400">{message}</p>}
        {error && <p className="text-sm text-red-400">{error}</p>}
        <button className="px-6 py-2 rounded-lg bg-brand-gradient text-white font-semibold">
          Save Changes
        </button>
      </form>
    </div>
  );
}
